// extracted by mini-css-extract-plugin
export const root = "k_c";